import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { RouterModule } from "@angular/router";

import { CallToActionComponent } from "@hermes/aphrodite/call-to-action";
import {
    CarouselComponent,
    CarouselPartDirective,
} from "@hermes/aphrodite/carousel";
import {
    ImageVariantsGalleryPartDirective,
    ImageVariantsGalleryComponent,
} from "@hermes/aphrodite/image-variants-gallery";
import { PriceComponent } from "@hermes/aphrodite/price";
import {
    svgCross,
    svgEditText,
    svgCameraFlash,
    svgSliderSetting,
    svgCrossRounded,
    SvgRegistryService,
    SvgIconComponent,
} from "@hermes/aphrodite/svg";
import { TagComponent } from "@hermes/aphrodite/tag";
import { VideoComponent } from "@hermes/aphrodite/video";
import { GridEditoModule } from "@hermes/fragments/grid-edito";
import { ImageResizerModule } from "@hermes/fragments/image-resizer";
import { OutOfStockLabelComponent } from "@hermes/fragments/out-of-stock-label";
import { PersonalizeLabelComponent } from "@hermes/fragments/personalize-label";
import { QuickBuyModule } from "@hermes/fragments/quick-buy";
import { SeoLinksModule } from "@hermes/fragments/seo-links";
import { VtoBeautyModalModule } from "@hermes/fragments/vto-beauty-modal";
import { GridFiltersStateModule } from "@hermes/states/grid-filters-state";

import { SrOnlyNoSnippetDirective } from "@hermes/utils-generic/directives/sr-only-no-snippet";

import { GridHeaderComponent } from "./components/grid-header/grid-header.component";
import { GridHighlightComponent } from "./components/grid-highlight/grid-highlight.component";
import { GridHighlightItemComponent } from "./components/grid-highlight-item/grid-highlight-item.component";
import { GridNoResultComponent } from "./components/grid-no-result/grid-no-result.component";
import { GridPageBannerComponent } from "./components/grid-page-banner/grid-page-banner.component";

import { GridResultAlternativeViewsComponent } from "./components/grid-result-alternative-views/grid-result-alternative-views.component";
import { GridResultFooterComponent } from "./components/grid-result-footer/grid-result-footer.component";
import { GridResultItemComponent } from "./components/grid-result-item/grid-result-item.component";
import { GridResultLoaderComponent } from "./components/grid-result-loader/grid-result-loader.component";
import { GridResultSearchHeaderComponent } from "./components/grid-result-search-header/grid-result-search-header.component";
import { GridResultsComponent } from "./components/grid-results/grid-results.component";
import { GridSeoTextComponent } from "./components/grid-seo-text/grid-seo-text.component";
import { SeoPaginationLinksComponent } from "./components/seo-pagination-links/seo-pagination-links.component";
import { FilterHatchService } from "./services/filter-hatch-service/filter-hatch.service";
import { ProductInViewportService } from "./services/product-in-viewport-service/product-in-viewport.service";
@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        SeoLinksModule,
        GridFiltersStateModule,
        CarouselComponent,
        CarouselPartDirective,
        SvgIconComponent,
        TagComponent,
        CallToActionComponent,
        VideoComponent,
        OutOfStockLabelComponent,
        ImageResizerModule,
        ImageVariantsGalleryComponent,
        ImageVariantsGalleryPartDirective,
        PriceComponent,
        PersonalizeLabelComponent,
        QuickBuyModule,
        GridEditoModule,
        SrOnlyNoSnippetDirective,
        VtoBeautyModalModule,
    ],
    declarations: [
        SeoPaginationLinksComponent,
        GridPageBannerComponent,
        GridResultSearchHeaderComponent,
        GridNoResultComponent,
        GridHeaderComponent,
        GridHighlightComponent,
        GridHighlightItemComponent,
        GridResultAlternativeViewsComponent,
        GridResultItemComponent,
        GridResultLoaderComponent,
        GridResultFooterComponent,
        GridSeoTextComponent,
        GridResultsComponent,
    ],
    exports: [
        SeoPaginationLinksComponent,
        GridPageBannerComponent,
        GridResultSearchHeaderComponent,
        GridNoResultComponent,
        GridHeaderComponent,
        GridHighlightComponent,
        GridHighlightItemComponent,
        GridResultAlternativeViewsComponent,
        GridResultItemComponent,
        GridResultLoaderComponent,
        GridResultFooterComponent,
        GridSeoTextComponent,
        GridResultsComponent,
    ],
    providers: [ProductInViewportService, FilterHatchService],
})
export class GridPageModule {
    constructor(svgRegistryService: SvgRegistryService) {
        svgRegistryService.registerSvgs([
            svgCross,
            svgCameraFlash,
            svgEditText,
            svgSliderSetting,
            svgCrossRounded,
        ]);
    }
}
